import { ChangeDetectionStrategy, Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { FormControl, FormGroup, UntypedFormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ErrorService } from '@portal-core/errors/services/error.service';
import { LicenseUser } from '@portal-core/license-users/models/license-user.model';
import { License } from '@portal-core/licenses/models/license.model';
import { LicensesService } from '@portal-core/licenses/services/licenses.service';
import { DialogBase } from '@portal-core/ui/dialog/util/dialog.base';
import { SnackBarAutoDismissDurationMS } from '@portal-core/ui/snack-bar/constants/snack-bar-auto-dismiss-duration.constant';
import { LoadingState } from '@portal-core/util/loading-state';


export interface LicenseContactSalesDialogData {
  license: License;
  licenseUser: LicenseUser;
}

@Component({
  selector: 'mc-license-contact-sales-dialog',
  templateUrl: './license-contact-sales-dialog.component.html',
  styleUrls: ['./license-contact-sales-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LicenseContactSalesDialogComponent extends DialogBase implements OnInit {
  static DialogConfig: MatDialogConfig = {
    width: '96rem',
    height: '71rem'
  };

  license: License;
  licenseUser: LicenseUser;

  contactForm: UntypedFormGroup;
  message: FormControl;

  savingState: LoadingState<string> = new LoadingState<string>();

  constructor(
    @Inject(MAT_DIALOG_DATA) private data: LicenseContactSalesDialogData,
    protected dialog: MatDialog,
    protected dialogRef: MatDialogRef<LicenseContactSalesDialogData>,
    private licensesService: LicensesService,
    private errorService: ErrorService,
    private snackBar: MatSnackBar,
  ) {
    super(dialog, dialogRef);
  }

  ngOnInit() {
    super.ngOnInit();

    this.license = this.data.license;
    this.licenseUser = this.data.licenseUser;

    this.buildForm();
  }

  private buildForm() {
    this.contactForm = new FormGroup({
      message: new FormControl('', [Validators.required, Validators.maxLength(2000)])
    });
  }

  onSubmit() {
    this.savingState.update(true);

    const message = this.contactForm.get('message')?.value;

    this.licensesService.emailMadCapSalesTeam$(this.license.Id, message)
      .subscribe(() => {
        this.savingState.update(false);

        this.snackBar.open('Email has been sent.', 'OK', {
          duration: SnackBarAutoDismissDurationMS
        });
        this.closeDialog();
      },
        error => {
          this.savingState.update(false, 'Failed to send email.', this.errorService.getErrorMessages(error));
        });
  }
}
